import { Box, Typography } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const EntityBlock = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  padding: theme.spacing(0.75, 2),
  color: "inherit",
  backgroundColor: theme.palette.background.paper,
  transition: "background-color 0.15s",
  cursor: "pointer",
  width: "100%",

  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const EntityImage = styled("img")({
  width: 56,
  height: 56,
  borderRadius: 8,
  objectFit: "cover",
  flexShrink: 0,
});

export const EntityImagePlaceholder = styled(Box)(({ theme }) => ({
  width: 56,
  height: 56,
  borderRadius: 8,
  flexShrink: 0,
  backgroundColor: theme.palette.action.selected,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const InsightsImagePlaceholder = styled(EntityImagePlaceholder)(
  ({ theme }) => ({
    backgroundColor: alpha(theme.palette.info.main, 0.1),
  })
);

export const EntityInfo = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 2,
  flex: 1,
  minWidth: 0,
});

export const EntityTitle = styled(Typography)({
  fontWeight: 600,
  lineHeight: 1.3,
});

export const EntitySubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));
